import { PlaceholderCaliberTab } from '@/components/PlaceholderCaliberTab';
import type { ContentfulPlaceholderServiceFragment } from '@/graphql/contentful/api';
import type { PlaceholderServiceType } from '@/integrations/contentful';
import { ArchivesForm } from '@/views/ArchivesView/ArchivesForm';

import { PlaceholderBuckleTable } from '../PlaceholderBuckleTable/PlaceholderBuckleTable';
import { PlaceholderPrint } from '../PlaceholderPrint/PlaceholderPrint';
import { IdentifyWatchWithResult } from './components/IdentifyWatchWithResult';
import { ServiceDropOff } from './components/ServiceDropOff';
import { ServicePricesSearch } from './components/ServicePricesSearch/ServicePricesSearch';
import { ServiceStatus } from './components/ServiceStatus';

export const renderContentfulPlaceholderServiceSection = (
  _props: ContentfulPlaceholderServiceFragment,
) => {
  const typename = _props?.type as PlaceholderServiceType;
  switch (typename) {
    case 'IdentifyWatch':
      return <IdentifyWatchWithResult {..._props}></IdentifyWatchWithResult>;
    case 'ServiceStatus':
      return <ServiceStatus {..._props}></ServiceStatus>;
    case 'DropOff':
      return <ServiceDropOff {..._props}></ServiceDropOff>;
    case 'ServicePricesSearch':
      return <ServicePricesSearch {..._props}></ServicePricesSearch>;
    case 'Print':
      return <PlaceholderPrint {..._props}></PlaceholderPrint>;
    case 'CaliberNonManufacture':
    case 'CaliberTab':
      return <PlaceholderCaliberTab {..._props}></PlaceholderCaliberTab>;
    case 'BuckleTable':
      return <PlaceholderBuckleTable></PlaceholderBuckleTable>;
    case 'ArchivesForm':
      return <ArchivesForm />;
    default:
      return null;
  }
};
